module.exports = __webpack_public_path__ + "static/media/discord.22f2c283.svg";